export { default as useLifestyleAttach } from './useLifestyleAttach';
